var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.visible,"width":"1200px","title":"充电记录地图","close-on-click-modal":false,"custom-class":"charging-record-map-dialog"},on:{"update:visible":function($event){_vm.visible=$event},"opened":_vm.initMap,"closed":_vm.clearMap}},[_c('div',{staticClass:"map-container",attrs:{"id":"chargingRecordMap"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }